module.exports = __webpack_public_path__ + "img/arrSearch.18d86b06.svg";